import React from "react";
import { benefits } from "./landingContent";

export default function LandingBenefits() {
  return (
    <section className="hr-landing-section" aria-labelledby="hr-landing-benefits-title">
      <div className="home-page__container">
        <header className="hr-landing-section__head">
          <h2 id="hr-landing-benefits-title" className="hr-landing-section__title">
            למה זה עובד טוב יותר מול לקוח ומול העסק
          </h2>
          <p className="hr-landing-section__lead">
            מסרים עסקיים, בלי רעש — מה שסוכן מרגיש אחרי שבועיים בתוך המערכת.
          </p>
        </header>
        <ul className="hr-landing-benefits">
          {benefits.map((b, i) => (
            <li key={i} className="hr-landing-benefit">
              <span className="hr-landing-benefit__mark" aria-hidden />
              <div>
                <h3 className="hr-landing-benefit__title">{b.title}</h3>
                <p className="hr-landing-benefit__text">{b.text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
